import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import FormLabel from "@mui/material/FormLabel";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "@mui/icons-material/Upload";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

import { showToast } from "../../store/actions";
import { ButtonUI } from "../Common/Common";
import ProductService from "../../service/product";

const useStyles = makeStyles((theme) =>
  createStyles({
    formLabel: {
      display: "flex",
      flexDirection: "row",
      "& .MuiFormLabel-root": {
        display: "inline-flex",
        width: "100%",
      },
      "& .MuiFormLabel-root.Status": {
        display: "inline-flex",
        width: "auto",
        alignItems: "center",
        color: "#000000de",
      },
      "& .MuiFormControlLabel-root": {
        display: "inline-flex",
        width: "fit-content",
        height: "30px",
      },
    },
    CheckboxContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      flexWrap: "wrap",
    },
    dialogPaper: {
      "& .MuiPaper-root": {
        maxWidth: "710px",
      },
      "& .MuiFormHelperText-root": {
        margin: 0,
        padding: 0,
      },
      "& .MuiGrid-item": {
        paddingTop: "15px",
      },
      "& .MuiGrid-item .MuiTextField-root": {
        marginTop: 0,
      },
      "& .MuiDivider-root": {
        marginTop: "5px",
        marginBottom: "9px",
      },
      "& .MuiDialogActions-root": {
        padding: "15px 20px 20px 0",
      },
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      padding: "0px 15px",
      textAlign: "left",
      minHeight: "250px",
    },
    container: {
      padding: "5px 5px 0 5px",
      backgroundColor: "#FFFFFF",
    },
    HalfTextField: {
      width: "calc(50% - 8px)",
    },
    Toolbar: {
      fontSize: "1.1rem",
      backgroundColor: "white",
      color: "black",
    },
    [theme.breakpoints.down("600")]: {
      HalfTextField: {
        width: "calc(100%)",
      },
    },
    fileContainer: {
      padding: "8px 15px",
      background: "#1976d2",
      color: "#fff",
      borderTopLeftRadius: "5px",
      borderBottomLeftRadius: "5px",
    },
    fileNameContainer: {
      paddingLeft: "10px",
    },
  })
);

export default function AddForm({ setOpen, loadProductdata, productId, categories }) {
  const [productName, setProductName] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionTwo, setDescriptionTwo] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [imageFile, setImageFile] = useState();
  const [imageFilePath, setImageFilePath] = useState("");
  const [deleteImage, setDeleteImage] = useState(0);
  const [priceList, setPriceList] = useState([]);
  const [priceValidation, setPriceValidation] = useState(false);

  const categoriesList = categories.filter((ct) => ct.value != -1);
  const [category, setCategory] = useState(categoriesList[0].value);

  const [errors, setErrors] = useState({
    productName: false,
    description: false,
    descriptionTwo: false,
    sortOrder: false,
  });

  const [active, setActive] = useState(1);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();
  const upload = useRef(null);

  const handleSave = async () => {
    setErrors((prevState) => {
      return {
        ...prevState,
        productName: productName.trim().length < 2 || productName.trim().length > 50,
        description: description.trim().length < 20 || description.trim().length > 500,
        descriptionTwo:
          descriptionTwo !== "" && (descriptionTwo.trim().length < 20 || descriptionTwo.trim().length > 255),
        sortOrder: sortOrder === "",
      };
    });

    if (
      !(
        productName.trim().length < 2 ||
        productName.trim().length > 50 ||
        description.trim().length < 20 ||
        description.trim().length > 500 ||
        (descriptionTwo !== "" && (descriptionTwo.trim().length < 20 || descriptionTwo.trim().length > 255)) ||
        sortOrder === ""
      )
    ) {
      setLoading(true);

      // Use FormData for uploading image
      const submitData = new FormData();

      submitData.append("Name", productName.trim());
      submitData.append("Category_id", category);
      submitData.append("Description", description.trim());
      submitData.append("Description2", descriptionTwo.trim());
      submitData.append("SortOrder", sortOrder);
      submitData.append("productImg", imageFile);
      submitData.append("Status", active);
      submitData.append("DeleteImage", deleteImage);
      submitData.append("PriceList", JSON.stringify(priceList));

      let result = null;

      const productService = new ProductService();

      if (productId > 0) {
        // Update Product
        result = await productService.updateProduct(productId, submitData);
      } else {
        // Add new Product
        result = await productService.addProduct(submitData);
      }

      if (result.success) {
        dispatch(
          showToast({
            message: result.message,
            type: "success",
          })
        );

        setOpen(false);
        loadProductdata();
      }
    }

    setLoading(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const clearFormData = () => {
    setProductName("");
    setDescription("");
    setDescriptionTwo("");
    setSortOrder("");
    setImageFile();
    setImageFilePath("");
    setActive(0);
    setErrors({
      productName: false,
      description: false,
      descriptionTwo: false,
      sortOrder: false,
    });
  };

  // Upload file
  const handleUploadFile = (e) => {
    const uploadedFiles = e.target.files;

    if (uploadedFiles && uploadedFiles.length) {
      setLoading(true);
      setImageFile(uploadedFiles[0]);
      setImageFilePath("");
      dispatch(showToast({ message: "Image uploaded successfully.", type: "success" }));
      setLoading(false);
    }

    e.target.value = null;
  };

  const handleImageDelete = () => {
    setImageFilePath("");
    setDeleteImage(1);
  };

  const handleAddPrice = () => {
    setPriceList([...priceList, { Quantity: "", Price: "" }]);
  };

  const handleRemovePrice = (index) => {
    const prList = [...priceList];
    prList.splice(index, 1);
    setPriceList(prList);
  };

  const handleInputQuantityChange = (e, index) => {
    const prList = [...priceList];
    prList[index]["Quantity"] = e.target.value;
    setPriceList(prList);
  };

  const handleInputPriceChange = (e, index) => {
    const prList = [...priceList];
    prList[index]["Price"] = e.target.value;
    setPriceList(prList);
  };

  useEffect(() => {
    const productService = new ProductService();

    const getProductData = async () => {
      setLoading(true);
      const result = await productService.getProductById(productId);

      if (result.success && result.data && Object.keys(result.data).length > 0) {
        const userData = result.data;

        setProductName(userData.Name);
        setImageFilePath(userData.File);
        setDescription(userData.Description);
        setDescriptionTwo(userData.Description2);
        setSortOrder(userData.SortOrder);
        setActive(userData.Status);
        setPriceList(userData.Prices);
        setCategory(userData.Category_id);
      }

      setLoading(false);
    };
    if (productId > 0) getProductData();

    return () => clearFormData();
  }, [productId]);

  useEffect(() => {
    var priceValid = true;

    // Check if Quantity or Price are empty, then disable save button
    let filteredPriceList = priceList.filter((pl) => pl.Quantity === "" || pl.Price === "");

    if (filteredPriceList.length > 0) {
      priceValid = false;
    }

    setPriceValidation(priceValid);
  }, [priceList]);

  return (
    <Dialog className={classes.dialogPaper} open={true}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>{productId > 0 ? "Edit" : "Add"} Product</Toolbar>
        <IconButton
          aria-label="close"
          onClick={() => handleCancel()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <Box sx={{ width: "100%" }} className={classes.container}>
        <Backdrop sx={{ color: "red", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                autoFocus
                margin="dense"
                fullWidth
                label="Name"
                type="text"
                variant="outlined"
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
                error={errors.productName}
                helperText={errors.productName ? "Product name length should be between 2 and 50!" : ""}
                required
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                margin="normal"
                label="Category"
                variant="outlined"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                select
                sx={{ mr: "20px", mt: 0, width: "200px" }}
              >
                {categoriesList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={12} md={12}>
              <input
                type="file"
                accept="image/*"
                ref={upload}
                style={{ display: "none" }}
                onChange={handleUploadFile}
              />
              <ButtonUI
                color="info"
                variant="outlined"
                style={{
                  width: "auto",
                  borderRadius: "5px",
                  padding: 0,
                  paddingRight: "15px",
                }}
                onClick={() => upload.current.click()}
                endIcon={<UploadIcon />}
              >
                <Box className={classes.fileContainer}>Choose File</Box>
                <Box className={classes.fileNameContainer}>{imageFile ? imageFile.name : "No file chosen.."}</Box>
              </ButtonUI>
            </Grid>

            {imageFilePath && (
              <Grid item xs={12} md={12} style={{ display: "flex", alignItems: "center" }}>
                <img
                  crossOrigin="anonymous"
                  alt="Product"
                  src={
                    imageFilePath
                      ? process.env.REACT_APP_API_URL + "/" + imageFilePath
                      : process.env.REACT_APP_API_URL + "/file/products/NoImageAvailable.png"
                  }
                  style={{
                    width: "80px",
                    height: "80px",
                  }}
                />

                <ButtonUI
                  variant="contained"
                  color="error"
                  style={{
                    padding: "2px 10px",
                    borderRadius: "5px",
                    marginLeft: "20px",
                  }}
                  onClick={handleImageDelete}
                >
                  Delete
                </ButtonUI>
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                margin="dense"
                fullWidth
                label="Description"
                type="text"
                variant="outlined"
                value={description}
                error={errors.description}
                helperText={errors.description ? "Description length should be between 20 and 500!" : ""}
                onChange={(e) => setDescription(e.target.value)}
                required
                multiline={true}
                minRows={4}
                maxRows={4}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                margin="dense"
                fullWidth
                label="Description 2"
                type="text"
                variant="outlined"
                value={descriptionTwo}
                error={errors.descriptionTwo}
                helperText={errors.descriptionTwo ? "Description 2 length should be between 20 and 255!" : ""}
                onChange={(e) => setDescriptionTwo(e.target.value)}
                multiline={true}
                minRows={4}
                maxRows={4}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                margin="dense"
                fullWidth
                label="Sort Order"
                type="number"
                variant="outlined"
                error={errors.sortOrder}
                helperText={errors.sortOrder ? "Please add valid Sort Order." : ""}
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                required
              />
            </Grid>

            <Grid item sm={6} xs={6} lg={6} md={6}>
              <FormGroup className={classes.formLabel}>
                <FormLabel>Status:</FormLabel>
                <FormLabel className="Status">Inactive</FormLabel>
                <Switch
                  checked={active !== undefined && active ? true : false}
                  color={active !== undefined ? "success" : ""}
                  onChange={(e) => setActive(+!active)}
                />
                <FormLabel className="Status">Active</FormLabel>
              </FormGroup>
            </Grid>

            <Grid item xs={12} md={12} style={{ display: "flex" }}>
              <span style={{ fontWeight: "bold" }}> Price </span>

              <AddCircleIcon
                color="success"
                style={{ cursor: "pointer", marginLeft: "10px" }}
                onClick={() => handleAddPrice()}
              />
            </Grid>

            {priceList.map((p, i) => (
              <Grid container key={i} style={{ paddingLeft: "16px" }}>
                <Grid item xs={5}>
                  <TextField
                    margin="dense"
                    fullWidth
                    label="Quantity"
                    type="number"
                    variant="outlined"
                    id={"quantityInput_" + i}
                    value={p.Quantity}
                    sx={{ pr: 2, mb: 0 }}
                    onChange={(e) => handleInputQuantityChange(e, i)}
                  />
                </Grid>

                <Grid item xs={5}>
                  <TextField
                    margin="dense"
                    fullWidth
                    label="Price"
                    type="number"
                    variant="outlined"
                    id={"priceInput_" + i}
                    value={p.Price}
                    sx={{ pr: 2, mb: 0 }}
                    onChange={(e) => handleInputPriceChange(e, i)}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                  />
                </Grid>

                <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
                  <RemoveCircleIcon color="error" style={{ cursor: "pointer" }} onClick={() => handleRemovePrice(i)} />
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box>
          <DialogActions>
            <ButtonUI variant="contained" color="secondary" onClick={handleCancel}>
              Cancel
            </ButtonUI>
            <ButtonUI
              onClick={handleSave}
              variant="contained"
              color="success"
              style={{ marginLeft: 15 }}
              disabled={!(productName.trim() && description.trim() && priceValidation) || loading}
            >
              Save
            </ButtonUI>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
}
